import {
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import FetchHook from "../../../Api/FetchHooks";
import { useLocation } from "react-router-dom";
import { getUserDetails } from "../../../utils/helpers";
import TransactionTable from "../../../Components/TransactionTable";
import AlertComponent from "../../../Components/AlertComponent";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import UseServerTable from "../../../Hooks/UseServerTable";
import Page from "../../../Components/Page";

const UserTransactions = ({ showHeader = true }) => {
  const location = useLocation();
  const LoggedInUser = getUserDetails();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [user, setUser] = useState(location.state?.user || LoggedInUser);
  const [status, setStatus] = useState("active");
  const [transactions, setTransactions] = useState([]);

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const [loading, response, request] = FetchHook();

  // const fetchTransactions = useCallback(async () => {
  //   await request({
  //     url: `/transaction?filter_value=${user?.id}&type=in_wallet&status=${status}`,
  //   });
  // }, [user?.id, status]);

  // useEffect(() => {
  //   fetchTransactions();
  // }, [fetchTransactions]);

  // useEffect(() => {
  //   if (response?.data?.Data) setTransactions(response.data.Data);
  // }, [response]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `/transaction?filter_value=${user?.id}&type=in_wallet&status=${status}`,
    onSuccess: (data) => {
      setTransactions(data.Data);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "transaction_id",
      headerName: "Transaction id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "source_transaction_id",
      headerName: "Source transaction id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "account_number",
      headerName: "Account number",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "loan_id",
      headerName: "Loan id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "global_request_id",
      headerName: "Global request id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "dr_cr_pair_id",
      headerName: "Dr Cr pair",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "debit",
      headerName: "Debit (money out)",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "credit",
      headerName: "Credit (money in)",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "balance_before",
      headerName: "Balance before",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "balance_after",
      headerName: "Balance after",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 300,
      flex: 1,
    },
    {
      field: "transaction_status",
      headerName: "Status",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "transaction_settlement_time",
      headerName: "Transaction settlement time",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    {
      field: "transaction_timestamp",
      headerName: "Transaction time",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   renderCell: (row) => (
    //     <Button
    //       variant="contained"
    //       style={{ marginLeft: 16, fontWeight: "bold" }}
    //       disabled={row.row.status === 1 ? false : true}
    //       onClick={() => fixLoanRequest(row.row)}
    //     >
    //       {fixLoading ? "Fixing..." : "Fix request"}
    //     </Button>
    //   ),
    //   width: 200,
    // },
  ];

  const custCols = [
    {
      field: "transaction_id",
      headerName: "Transaction id",
      width: 170,
    },
    {
      field: "transaction_timestamp",
      headerName: "Transaction time",
      minWidth: 200,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    {
      field: "debit",
      headerName: "Debit (money out)",
    },
    {
      field: "credit",
      headerName: "Credit (money in)",
    },
    // {
    //   field: "balance_before",
    //   headerName: "Balance before",
    // },
    {
      field: "balance_after",
      headerName: "Balance",
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 350,
    },
    {
      field: "transaction_status",
      headerName: "Status",
    },
  ];

  return (
    <Page title={"Recent Transactions"} showHeader={showHeader}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />
      <Card>
        <CardHeader
          title={
            <>
              {showHeader === false && (
                <Typography variant="h6">Recent Transactions</Typography>
              )}
            </>
          }
          // action={
          //   <Box display={"flex"}>
          //     <FormControl
          //       sx={{
          //         width: "20vw",
          //         mr: "20px",
          //       }}
          //     >
          //       <InputLabel id="status" size="small">
          //         Status
          //       </InputLabel>

          //       <Select
          //         labelId="loan_status"
          //         id="loan_status"
          //         value={status}
          //         label="status"
          //         onChange={(e) => {
          //           setStatus(e.target.value);
          //         }}
          //         size="small"
          //         defaultValue="active"
          //       >
          //         <MenuItem value="active">Active</MenuItem>
          //         <MenuItem value="inactive">Inactive</MenuItem>
          //         <MenuItem value="domant">Dormant</MenuItem>
          //         <MenuItem value="suspended">Suspended</MenuItem>
          //         <MenuItem value="closed">Closed</MenuItem>
          //         <MenuItem value="pending">Pending</MenuItem>
          //         <MenuItem value="cancelled">Cancelled</MenuItem>
          //       </Select>
          //     </FormControl>
          //   </Box>
          // }
        />
        <CardContent>
          {transactions && transactions.length > 0 ? (
            <>
              <TransactionTable data={transactions} {...gridProps} />
            </>
          ) : gridProps.loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <Grid
              container
              display={"flex"}
              direction={"column"}
              alignContent={"center"}
              justifyContent={"center"}
            >
              <AllInboxIcon color="error" sx={{ mx: "auto", fontSize: 80 }} />
              <Typography>No recent transactions</Typography>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default UserTransactions;
